import { render, staticRenderFns } from "./AccreditationEventMobileCard.vue?vue&type=template&id=2e550fe7&scoped=true&"
import script from "./AccreditationEventMobileCard.vue?vue&type=script&lang=js&"
export * from "./AccreditationEventMobileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e550fe7",
  null
  
)

export default component.exports